// extracted by css-extract-rspack-plugin
export default {"root":"Mo0vy","chartContainer":"SgW5S","exploreButtonOverlay":"Rr5qW","descriptionSection":"X8vII","visualizationPanel":"lS0zv","innerVisualization":"YQAtY"};